import React from 'react';
import { Star, Check, X } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carlos M.',
    role: 'Padre futbolista Sub 15',
    location: 'Rosario',
    text: 'Mi hijo recuperó la confianza y dejó de hablar de abandonar.'
  }, {
    name: 'Mariana R.',
    role: 'Madre futbolista juvenil',
    location: 'Buenos Aires',
    text: 'Ahora sé cómo hablarle después de los partidos sin generar conflicto.'
  }, {
    name: 'Jorge S.',
    role: 'Padre',
    location: 'Córdoba',
    text: 'Aplicamos los ejercicios antes de competir y el cambio es evidente.'
  }, {
    name: 'Silvina G.',
    role: 'Madre',
    location: 'Mendoza',
    text: 'Entendí qué pasaba por su cabeza y cómo ayudarlo.'
  }];
  return <section className="w-full bg-gray-50 py-16 px-4" data-id="element-208">
      <div className="max-w-6xl mx-auto" data-id="element-209">
        {/* Para Quién Es / No Es */}
        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-210">
          <div className="bg-white p-8 rounded-2xl border-2 border-green-200 shadow-sm" data-id="element-211">
            <h3 className="text-xl font-black text-green-800 mb-6 uppercase" data-id="element-212">
              👨‍👩‍👦 PARA QUIÉN ES ESTE PROGRAMA
            </h3>
            <ul className="space-y-3" data-id="element-213">
              {['Padres con hijos en fútbol competitivo.', 'Jóvenes que sienten presión o frustración deportiva.', 'Familias que quieren acompañar sin generar más presión.', 'Padres que buscan intervenir correctamente.'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-214">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-215" />
                  <span className="text-gray-700" data-id="element-216">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl border-2 border-red-200 shadow-sm" data-id="element-217">
            <h3 className="text-xl font-black text-red-800 mb-6 uppercase" data-id="element-218">
              🚫 ESTE PROGRAMA NO ES PARA
            </h3>
            <ul className="space-y-3" data-id="element-219">
              {['Quien busca resultados mágicos.', 'Quien no quiere involucrarse activamente.', 'Quien no desea acompañar el proceso del jugador.'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-220">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-221" />
                  <span className="text-gray-700" data-id="element-222">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Testimonials */}
        <div className="text-center mb-12" data-id="element-223">
          <div className="inline-flex items-center gap-2 bg-green-50 border border-green-200 text-green-800 px-5 py-2 rounded-full text-sm font-bold mb-6" data-id="element-224">
            <span className="text-lg" data-id="element-225">⚽</span>
            MÁS DE 1.000 PADRES YA COMPRARON Y AYUDARON A SUS HIJOS
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4 uppercase" data-id="element-226">
            ⭐ RESULTADOS QUE REPORTAN LOS PADRES
          </h2>
          <div className="flex justify-center gap-1 mb-4" data-id="element-227">
            {[1, 2, 3, 4, 5].map((_, i) => <Star key={i} className="w-8 h-8 text-yellow-400 fill-current" data-id="element-228" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-229">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-230">
              <div className="flex gap-1 mb-3" data-id="element-231">
                {[1, 2, 3, 4, 5].map((_, j) => <Star key={j} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-232" />)}
              </div>
              <p className="text-gray-700 italic mb-4" data-id="element-233">"{t.text}"</p>
              <div className="flex items-center gap-3 border-t pt-3" data-id="element-234">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center font-bold text-green-700" data-id="element-235">
                  {t.name[0]}
                </div>
                <div data-id="element-236">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-237">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-238">
                    {t.role} — {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Por Qué Funciona */}
        <div className="text-center max-w-3xl mx-auto" data-id="element-239">
          <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-240">
            💥 POR QUÉ FUNCIONA
          </h3>
          <p className="text-lg text-gray-700 mb-2" data-id="element-241">
            No mejora solo el juego.{' '}
            <span className="font-bold" data-id="element-242">Mejora el entorno emocional.</span>
          </p>
          <p className="text-gray-600 mb-8" data-id="element-243">Cuando el entorno mejora:</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-244">
            {['aumenta la confianza', 'mejora el rendimiento', 'disminuye el miedo al error', 'vuelve la motivación deportiva'].map((item, i) => <div key={i} className="bg-white p-3 rounded-lg shadow-sm border border-green-100 text-sm font-bold text-green-800 uppercase" data-id="element-245">
                ✔ {item}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}